module.exports = __webpack_public_path__ + "media/images/email_sent-27a5ec0ed9ba5149883feea5fcf87544.svg";